import {
    get_common_create_layer_options,
    calculate_pane_opacity,
} from "@/utils/emap/common_layer.js"

export const FORMAT_URL_CALLBACK_MAPPING = {
    pixel: format_pixel_url_callback,
    symbol: format_symbol_url_callback,
    multi: format_multi_url_callback,
}

export const get_common_create_render_type_options = (product, selected_products) => {
    return {
        ...get_common_create_layer_options(product),
        type: 'render',
        pane_opacity: calculate_pane_opacity(selected_products),
    }
}

export const generate_data_by_render_sub_type = ({ header_path, files, id, product_type }, current_timestamp) => {
    const format_url_callback = FORMAT_URL_CALLBACK_MAPPING[product_type]
    let input_file = []

    if (typeof files !== 'string') {
        const current_time_file = files
            .filter(({ data_time_timestamp }) => data_time_timestamp === current_timestamp)
            .map(datum_file => {
                return {
                    key: `${id}_${datum_file['data_time_timestamp']}`,
                    url: format_url_callback(datum_file)
                }
            })

        // 不做一個假資料餵給 kxd 會出錯
        const no_data_file = [{
            key: `${id}_${current_timestamp}`,
            url: ''
        }]

        input_file = current_time_file.length > 0 ? current_time_file : no_data_file
    } else {
        input_file = [{ key: 'monitor_map', url: files }]
    }

    return {
        header: header_path,
        list: input_file
    }
}

function format_pixel_url_callback(datum_file) { return datum_file['file_path'] }

function format_symbol_url_callback(datum_file) {
    return [
        datum_file['file_path_A'],
        datum_file['file_path_B'],
    ]
}

function format_multi_url_callback(datum_file) {
    return [
        datum_file['file_path_A'],
        datum_file['file_path_B'],
        datum_file['file_path_C'],
    ]
}

// special case

export const get_product_with_current_radar_angle = (product, current_radar_angle) => {
    const { header_path, files } = product
    return {
        ...product,
        header_path: header_path[current_radar_angle],
        files: files[current_radar_angle],
    }
}

export const generate_accumulated_precp_data = ({ header_path, files, id }) => {
    const current_file = files[0]
    return {
        header: header_path,
        list: [{
            key: `${id}_${current_file.data_time_timestamp}`,
            url: format_pixel_url_callback(current_file)
        }]
    }
}

export const get_wind_bar_style_multi_drawer = () => {
    const wind_bar_style = KXD.utility.class.symbol.WindBarStyle.createDefaultStyle();
    wind_bar_style.calmWindSmallRadius = 6; // 靜風時內圈小圓之半徑，若指定為0時則表示完全不畫(也就是靜風時不會有任何圖像)，預設為6
    wind_bar_style.symbolCenter = 'h';
    wind_bar_style.blockSizeScale = 0.8;

    return wind_bar_style
}

export const get_symbol_wind_style_drawer = () => {
    const wind_bar_style = KXD.utility.class.symbol.WindBarStyle.createDefaultStyle();
    wind_bar_style.calmWindSmallRadius = 0; // 靜風時內圈小圓之半徑，若指定為0時則表示完全不畫(也就是靜風時不會有任何圖像)

    return wind_bar_style
}

// 部分產品使用特定的文字colorbar, ex: 水相粒子分類HCA
export const get_render_colorbar_val_callback = (product) => {
    const { id, floating_number } = product

    //去除-9999的colorbar
    const invaild_val_id_list = ['id_370', 'id_371']
    if (invaild_val_id_list.includes(id)) {
        return {
            val_callback: (val) => {
                if (val === -9999) return ''
                return val.toFixed(floating_number)
            },
        }
    }

    //使用文字colorbar
    const hca_id_list = ['id_4109', 'id_4110', 'id_4111', 'id_4112', 'id_4113', 'id_4114', 'id_4115', 'id_4116', 'id_4117', 'id_4118', 'id_4119', 'id_4120', 'id_4121', 'id_4122', 'id_4509', 'id_4510', 'id_4511', 'id_4512', 'id_4513', 'id_4514', 'id_4515', 'id_4516', 'id_4517', 'id_4518', 'id_4519', 'id_4520', 'id_4521', 'id_4522', 'id_4709', 'id_4710', 'id_4711', 'id_4712', 'id_4713', 'id_4714', 'id_4715', 'id_4716', 'id_4717', 'id_4718', 'id_4719', 'id_4720', 'id_4721', 'id_4722', 'id_4909', 'id_4910', 'id_4911', 'id_4912', 'id_4913', 'id_4914', 'id_4915', 'id_4916', 'id_4917', 'id_4918', 'id_4919', 'id_4920', 'id_4921', 'id_4922', 'id_5077', 'id_5078', 'id_5079', 'id_5277', 'id_5278', 'id_5279', 'id_5477', 'id_5478', 'id_5479', 'id_5861', 'id_5862', 'id_5863', 'id_5864', 'id_6061', 'id_6062', 'id_6063', 'id_6064', 'id_7090', 'id_7091', 'id_7092', 'id_7093', 'id_7290', 'id_7291', 'id_7292', 'id_7293', 'id_7490', 'id_7491', 'id_7492', 'id_7493']
    if (hca_id_list.includes(id)) {
        const hca_val_map = {
            '0.1': 'L/MR',
            '0.2': 'HR',
            '0.3': 'R/Ha',
            '0.4': 'BD',
            '0.5': 'GC',
            '0.6': 'BS',
            '0.7': 'UK',
            '0.9': 'DS',
            '1.0': 'WS',
            '1.1': 'CR',
            '1.3': 'GR',
            '10': 'CR',
            '15': 'GR',
        }
        return {
            val_callback: (val) => {
                return hca_val_map[val.toFixed(1)]
            }
        }
    }

    return {
        val_callback: null
    }
}